import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/yuvalim';

export const pannellumConfigYuvalim: { [key: number]: TPannellumConfig } = {
  1: {
    hfov: 95,
    pitch: -10,
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: 3.3,
        yaw: -8.5,
        type: 'info',
        createTooltipArgs: { title: 'B1', type: 'building' },
      },
      {
        pitch: 3.3,
        yaw: 10,
        type: 'info',
        createTooltipArgs: { title: 'B2', type: 'building' },
      },
      {
        pitch: 5,
        yaw: -0.2,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene2.webp`,
        },
      },
      {
        pitch: -5.9120348909557165,
        yaw: 0.19439838845380564,
        type: 'info',
        createTooltipArgs: {
          title: 'שמורת זיתא ותל זרור',
          stem: 50,
          type: 'poi',
          cardDescription: 'שמורת זיתא ותל זרור',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 5, walk: 30, bicycle: 10 },
        },
      },
      {
        pitch: 1.3809688409779124,
        yaw: -112.01406108190258,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנה מרכזית חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנה מרכזית חדרה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 7, walk: 35, bicycle: 10 },
        },
      },
      {
        pitch: 1.1754994339984164,
        yaw: -120.67802982378782,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת חדרה',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 10, walk: 50, bicycle: 15 },
        },
      },
      {
        pitch: -1.564449316754743,
        yaw: 150.79130816162137,
        type: 'info',
        createTooltipArgs: {
          title: 'אגם האקו פארק',
          stem: 50,
          type: 'poi',
          cardDescription: 'אגם האקו פארק',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 10, bicycle: 2 },
        },
      },
    ],
  },
  2: {
    hfov: 120,
    pitch: -10,
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    hotSpots: [
      {
        pitch: 5,
        yaw: -0.2,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene1.webp`,
        },
      },
      {
        pitch: 0.8616248369288577,
        yaw: -0.9791772927305828,
        type: 'info',
        createTooltipArgs: {
          title: 'אגם האקו פארק',
          stem: 50,
          type: 'poi',
          cardDescription: 'אגם האקו פארק',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 10, bicycle: 2 },
        },
      },
      {
        pitch: 0.6906736773897095,
        yaw: 62.336366789738804,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת חדרה',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 10, walk: 50, bicycle: 15 },
        },
      },
      {
        pitch: 1.3483128537924398,
        yaw: 55.46939722853904,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנה מרכזית חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנה מרכזית חדרה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 7, walk: 35, bicycle: 10 },
        },
      },
      {
        pitch: 2.18627925677254,
        yaw: 164.4833385997356,
        type: 'info',
        createTooltipArgs: {
          title: 'שמורת זיתא ותל זרור',
          stem: 50,
          type: 'poi',
          cardDescription: 'שמורת זיתא ותל זרור',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 5, walk: 30, bicycle: 10 },
        },
      },
      {
        pitch: -48.76994632250934,
        yaw: 37.5707913171218,
        type: 'info',
        createTooltipArgs: {
          title: 'הפרדס ',
          type: 'building',
        },
      },
      {
        pitch: -62.53110868160061,
        yaw: 108.96527627628654,
        type: 'info',
        createTooltipArgs: {
          title: 'הזכוכית ',
          type: 'building',
        },
      },
      {
        pitch: -47.15444105529411,
        yaw: 98.37835342456128,
        type: 'info',
        createTooltipArgs: {
          title: 'יפה נוף ',
          type: 'building',
        },
      },
      {
        pitch: -34.38341447080519,
        yaw: 49.22373247099233,
        type: 'info',
        createTooltipArgs: {
          title: 'חטיבת הנחל ',
          type: 'building',
        },
      },
    ],
  },
};
